"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledReCaptchaError = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledReCaptchaError = _styledComponents["default"].div.withConfig({
  displayName: "ReCaptchastyles__StyledReCaptchaError",
  componentId: "sc-13yoqv3-0"
})(["", " font-size:", ";"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["sans-serif w-100 red pt1"]))), function (_ref) {
  var theme = _ref.theme;
  return theme.textInput.errorMessageFontSize || '0.875rem';
});

exports.StyledReCaptchaError = StyledReCaptchaError;